"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var util_1 = require("../../runtime/util");
var awsui_checkbox_1 = require("../checkbox/awsui-checkbox");
var SelectOptionWrapper = /** @class */ (function (_super) {
    __extends(SelectOptionWrapper, _super);
    function SelectOptionWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectOptionWrapper.prototype.findLabel = function () {
        return this.find('.awsui-select-option-label');
    };
    SelectOptionWrapper.prototype.findDescription = function () {
        return this.find('.awsui-select-option-description');
    };
    SelectOptionWrapper.prototype.findLabelTag = function () {
        return this.find('.awsui-select-option-label-tag');
    };
    SelectOptionWrapper.prototype.findTags = function () {
        return this.findAll('.awsui-select-option-tag');
    };
    /**
     * Returns a checkbox in a dropdown option.
     */
    SelectOptionWrapper.prototype.findCheckbox = function () {
        return new awsui_checkbox_1.default(this.find('awsui-checkbox').getElement());
    };
    return SelectOptionWrapper;
}(dom_1.ElementWrapper));
exports.SelectOptionWrapper = SelectOptionWrapper;
var mapToSelectOptionWrapper = function (elementWrappers) {
    return elementWrappers.map(function (elementWrapper) { return new SelectOptionWrapper(elementWrapper.getElement()); });
};
var SelectDropdownWrapper = /** @class */ (function (_super) {
    __extends(SelectDropdownWrapper, _super);
    function SelectDropdownWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectDropdownWrapper.prototype.findOptions = function () {
        return mapToSelectOptionWrapper(this.findAll('.awsui-select-option'));
    };
    /**
     * Returns an option from the dropdown.
     *
     * @param optionIndex 1-based index of the option to select.
     * @param settings Options to further specify the option to return.
     */
    SelectDropdownWrapper.prototype.findOption = function (optionIndex, settings) {
        if (settings === void 0) { settings = {}; }
        var extraSelector = '';
        if (settings.selected) {
            extraSelector = '.awsui-select-dropdown-option-selected';
        }
        var option = this.find(".awsui-select-dropdown-option:nth-child(" + optionIndex + ")" + extraSelector + " .awsui-select-option");
        return option ? new SelectOptionWrapper(option.getElement()) : null;
    };
    // Here we need two helpers with the same implementation because of the difference between
    // the implementation of  AutoSuggest and the one of the Select comp.
    // In AutoSuggest, item have a 'value' field and in the Select comp, items have an 'Id' field that both map to the data-value field.
    SelectDropdownWrapper.prototype.findOptionByValue = function (value) {
        var toReplace = util_1.escapeSelector(value);
        var option = this.find(".awsui-select-option[data-value=\"" + toReplace + "\"]");
        return option ? new SelectOptionWrapper(option.getElement()) : null;
    };
    SelectDropdownWrapper.prototype.findOptionById = function (id) {
        return this.findOptionByValue(id);
    };
    SelectDropdownWrapper.prototype.findGroups = function () {
        return this.findAll('.awsui-select-dropdown-options-group');
    };
    /**
     * Returns an option from the dropdown.
     *
     * @param groupIndex 1-based index of the group to select an option in.
     * @param optionIndex 1-based index of the option to select.
     * @param settings Options to further specify the option to return.
     */
    SelectDropdownWrapper.prototype.findOptionInGroup = function (groupIndex, optionIndex, settings) {
        if (settings === void 0) { settings = {}; }
        var extraSelector = '';
        if (settings.selected) {
            extraSelector = '.awsui-select-dropdown-option-selected';
        }
        var element = this.find(".awsui-select-dropdown-options-group:nth-child(" + groupIndex + ") .awsui-select-dropdown-option:nth-child(" + optionIndex + ")" + extraSelector + " .awsui-select-option").getElement();
        return new SelectOptionWrapper(element);
    };
    /**
     * Use this element to scroll through the list of options
     */
    SelectDropdownWrapper.prototype.findOptionsContainer = function () {
        return this.find('.awsui-select-dropdown-options-container');
    };
    /**
     * @deprecated Use respective test-utils for Autosuggest/Select/Multiselect components directly
     */
    SelectDropdownWrapper.prototype.findEmptyRegion = function () {
        return this.find('[awsui-select-dropdown-region="listBottom"]');
    };
    SelectDropdownWrapper.prototype.findFooterRegion = function () {
        return this.find('[awsui-select-dropdown-region="footer"]');
    };
    SelectDropdownWrapper.prototype.findOpenDropdown = function () {
        return this.find('.awsui-select-dropdown-open');
    };
    SelectDropdownWrapper.prototype.findSelectedOptions = function () {
        return mapToSelectOptionWrapper(this.findAll('.awsui-select-dropdown-option-selected .awsui-select-option'));
    };
    SelectDropdownWrapper.prototype.findHighlightedOption = function () {
        var option = this.find('.awsui-select-dropdown-option-highlighted .awsui-select-option');
        return option ? new SelectOptionWrapper(option.getElement()) : null;
    };
    SelectDropdownWrapper.prototype.findDisabledOptions = function () {
        return mapToSelectOptionWrapper(this.findAll('.awsui-select-dropdown-option-disabled .awsui-select-option'));
    };
    /**
     * Returns all options that are highlighted. Options are highlighted by operations like filtering.
     */
    SelectDropdownWrapper.prototype.findHighlightedMatches = function () {
        return mapToSelectOptionWrapper(this.findAll('.awsui-select-option-filtering-match-highlight'));
    };
    SelectDropdownWrapper.prototype.findHighlightedAriaLiveRegion = function () {
        return this.find('.awsui-select-dropdown>[aria-live]');
    };
    return SelectDropdownWrapper;
}(dom_1.ComponentWrapper));
exports.default = SelectDropdownWrapper;
//# sourceMappingURL=awsui-select-dropdown.js.map